// ------------------------------------
// Imports
// ------------------------------------

import { API_REQUEST_STATUS_LOADING, API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'

// ------------------------------------
// Constants
// ------------------------------------

export const GET_METRICS = 'GET_METRICS'
export const GET_METRICS_FAILED = 'GET_METRICS_FAILED'
export const GET_METRICS_SUCCEEDED = 'GET_METRICS_SUCCEEDED'

export const SEND_METRICS = 'SEND_METRICS'
export const SEND_METRICS_FAILED = 'SEND_METRICS_FAILED'
export const SEND_METRICS_SUCCEEDED = 'SEND_METRICS_SUCCEEDED'

// ------------------------------------
// Actions
// ------------------------------------

export function getMetrics(token, term) {
  return {
    type: GET_METRICS,
    token,
    term
  }
}

export function getMetricsFailed(error) {
  return {
    type: GET_METRICS_FAILED,
    error
  }
}

export function getMetricsSucceeded(data) {
  return {
    type: GET_METRICS_SUCCEEDED,
    payload: data
  }
}

export function sendMetrics(token, term, callback) {
  return {
    type: SEND_METRICS,
    token,
    term,
    callback
  }
}

export function sendMetricsFailed(error) {
  return {
    type: SEND_METRICS_FAILED,
    error
  }
}

export function sendMetricsSucceeded(data) {
  return {
    type: SEND_METRICS_SUCCEEDED
  }
}

export const actions = {
  getMetrics,
  getMetricsFailed,
  getMetricsSucceeded,
  sendMetrics,
  sendMetricsFailed,
  sendMetricsSucceeded
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

  [GET_METRICS]: (state, action) => ({
    ...state,
    getMetricsStatus: API_REQUEST_STATUS_LOADING,
    getMetricsError: -1
  }),

  [GET_METRICS_FAILED]: (state, action) => ({
    ...state,
    getMetricsStatus: API_REQUEST_STATUS_FAILED,
    getMetricsError: action.error
  }),

  [GET_METRICS_SUCCEEDED]: (state, action) => ({
    ...state,
    metrics: action.payload,
    getMetricsStatus: API_REQUEST_STATUS_SUCCEEDED,
    getMetricsError: -1
  }),

  [SEND_METRICS]: (state, action) => ({
    ...state,
    sendMetricsStatus: API_REQUEST_STATUS_LOADING,
    sendMetricsError: -1
  }),

  [SEND_METRICS_FAILED]: (state, action) => ({
    ...state,
    sendMetricsStatus: API_REQUEST_STATUS_FAILED,
    sendMetricsError: action.error
  }),

  [SEND_METRICS_SUCCEEDED]: (state, action) => ({
    ...state,
    sendMetricsStatus: API_REQUEST_STATUS_SUCCEEDED,
    sendMetricsError: -1
  })
}

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  metrics : {},
  getMetricsStatus: -1,
  getMetricsError: -1,

  sendMetricsStatus: -1,
  sendMetricsError: -1
}

export default function metricsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/modules/module_metrics.js